import { localStorage } from 'dibs-browser-storage';

const HAS_SEEN_FAVORITES_TOOLTIP = 'HAS_SEEN_FAVORITES_TOOLTIP';
const TRADE_SOURCING_PROMPT_VIEW_COUNT = 'TRADE_SOURCING_PROMPT_VIEW_COUNT';
const TRADE_SOURCING_PROMPT_IMPRESSION_CAP = 2;

export function hasSeenFavoritesTooltip() {
    return localStorage.getItem(HAS_SEEN_FAVORITES_TOOLTIP) || false;
}

export function logFavoritesTooltipView() {
    localStorage.setItem(HAS_SEEN_FAVORITES_TOOLTIP, true);
}

function getTradeSourcingPromptModalViewCount() {
    return localStorage.getItem(TRADE_SOURCING_PROMPT_VIEW_COUNT) || 0;
}

export function canShowTradeSourcingPromptModal() {
    const viewCount = getTradeSourcingPromptModalViewCount();
    return viewCount < TRADE_SOURCING_PROMPT_IMPRESSION_CAP;
}

export function logTradeSourcingPromptModalView() {
    const viewCount = getTradeSourcingPromptModalViewCount();
    localStorage.setItem(TRADE_SOURCING_PROMPT_VIEW_COUNT, viewCount + 1);
}
